export default "__VITE_ASSET__BIqPYH0___"